import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataUnspscsActions } from "./unspscs.actions";

// **************************************************************************
// UNSPSCS REDUCER
// **************************************************************************

const load = on(DataUnspscsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        unspsc: {
            ...state.data.unspsc,
            unspscsLoading: true,
        },
    },
}));

const loadSuccess = on(DataUnspscsActions.loadSuccess, (state: ApplicationStore, { unspscs }) => ({
    ...state,
    data: {
        ...state.data,
        unspsc: {
            ...state.data.unspsc,
            unspscs,
            unspscsLoading: false,
        },
    },
}));

const loadFailure = on(DataUnspscsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        unspsc: {
            ...state.data.unspsc,
            unspscsLoading: false,
        },
    },
}));

export const unspscsReducer = [load, loadSuccess, loadFailure];
